// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { autocompleteContentStyles } from "@insite/content-library/Widgets/Header/AutocompleteContent";
import { headerText, linkStyles } from "@vanmeter/App/SharedStyles/AutoCompleteSharedStyles";
import { color, ellipsis, mergeWithCss } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

autocompleteContentStyles.headerText = headerText;

autocompleteContentStyles.link = {
    ...mergeWithCss(linkStyles, {
        typographyProps: {
            css: css`
                ${ellipsis(2)}
            `,
        },
        css: css`
            margin-bottom: 10px;
        `,
    }),
};

autocompleteContentStyles.focusedLink = {
    ...mergeWithCss(linkStyles, {
        typographyProps: {
            css: css`
                ${ellipsis(2)}
            `,
        },
        css: css`
            background: ${color("common.ui3")};
            margin-bottom: 10px;
        `,
    }),
};
